import React, { useState, useEffect } from 'react'

const Cookie = () => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (
      'acceptedCookies' in localStorage &&
      localStorage.acceptedCookies === 'true'
    ) {
      setIsVisible(false)
    } else {
      setIsVisible(true)
    }
  }, [])

  const handleClose = e => {
    e.preventDefault()
    setIsVisible(false)
    localStorage.setItem('acceptedCookies', 'true')
  }

  return (
    <div
      className={`w-80 lg:w-96 fixed bottom-4 lg:bottom-8 right-4 lg:right-8 px-4 py-6 bg-white border border-gray-100 shadow-xl rounded-xl z-999 ${
        isVisible ? 'block' : 'hidden'
      }`}
    >
      <p className="text-sm mb-8 text-gray-900">
        Ao navegar em nosso site você concorda com a nossa política de
        privacidade.
      </p>
      <div>
        <a
          href="#"
          onClick={e => handleClose(e)}
          className="py-1 px-3 sm:py-2 sm:px-6 inline-flex mr-2 bg-secondary text-white rounded-lg"
        >
          OK
        </a>
        <a
          href="/politica-de-privacidade/"
          className="py-1 px-3 sm:py-2 sm:px-6 inline-flex mr-2 bg-secondary text-white rounded-lg"
        >
          Política de privacidade
        </a>
      </div>
    </div>
  )
}

export default Cookie
